(function($){

  var context = {
    init: function(){
      $("#offer_attachment_upload").change(function() {
        context.readURL(this);
      });
    },

    readURL: function(input){
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
          $('.offer-attachment-preview').attr('src', e.target.result);
          $(".preview-notice").addClass("d-none");
          $('.preview-creative > span.alert-danger').addClass('d-none');
          $('.preview-creative > span.alert-success').removeClass('d-none');
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
  };

  context.init();

})(jQuery);
